import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { useGetUser } from '../hooks/tanstack/useUserHook';
import routes from '../routes';

const UnAuthenticatedRoute = () => {
  const { data: currentUser, isFetchedAfterMount } = useGetUser();

  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser && isFetchedAfterMount) {
      navigate(routes.home);
    }
  }, [currentUser, isFetchedAfterMount]);

  return (
    <div>
      <Outlet />
    </div>
  );
};

export default UnAuthenticatedRoute;
